import dynamic from 'next/dynamic'

import { Loading } from '../../../loading'

export const DynamicPersonalAdviceDialogWithoutAccordionContent = dynamic(
  async () =>
    import('./PersonalAdviceDialogWithoutAccordionContent').then(
      (mod) => mod.PersonalAdviceDialogWithoutAccordionContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
